import React, { memo } from 'react'
import { Path } from 'react-native-svg'

import { IconBase } from '../IconBase'
import { IconProps } from '../IconProps'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        fill={`${color}`}
        d="M20.25 2.37524H3.75002C3.25274 2.37524 2.77582 2.57279 2.42419 2.92442C2.07256 3.27605 1.87502 3.75296 1.87502 4.25024V19.2502C1.87352 19.6073 1.97494 19.9573 2.16714 20.2582C2.35934 20.5591 2.63418 20.7983 2.95877 20.9471C3.20793 21.0638 3.47958 21.1246 3.7547 21.1252C4.19498 21.1241 4.62068 20.9674 4.95658 20.6827L4.96783 20.6724L7.91908 18.1252H20.25C20.7473 18.1252 21.2242 17.9277 21.5758 17.5761C21.9275 17.2244 22.125 16.7475 22.125 16.2502V4.25024C22.125 3.75296 21.9275 3.27605 21.5758 2.92442C21.2242 2.57279 20.7473 2.37524 20.25 2.37524ZM19.875 15.8752H7.50002C7.23 15.8748 6.96894 15.972 6.76502 16.149L4.12502 18.4281V4.62524H19.875V15.8752Z"
      />
    </IconBase>
  )
}

Icon.displayName = 'IconChat'

export const IconChat = memo(themed(Icon))
